import { TrailerType } from "../../graphql/generated";

const LIQUID_TRAILER_TYPES = [
  TrailerType.Tanker,
  TrailerType.TankWagon,
] as const;

export type ResolvedLiquidTrailerTypes = {
  trailerType: TrailerType;
  additionalTrailerTypes: TrailerType[];
};

/**
 * Maps org `defaultTrailerTypes` to primary + additional trailer types for liquid shipments.
 * Filters to liquid types, falls back to Tanker when empty, and canonicalizes Tanker before Tank Wagon.
 */
export function resolveDefaultLiquidTrailerTypes(
  defaultTrailerTypes?: TrailerType[] | null
): ResolvedLiquidTrailerTypes {
  const liquidTypes = (defaultTrailerTypes ?? []).filter(
    (type): type is (typeof LIQUID_TRAILER_TYPES)[number] =>
      LIQUID_TRAILER_TYPES.includes(
        type as (typeof LIQUID_TRAILER_TYPES)[number]
      )
  );

  const uniqueTypes = Array.from(new Set(liquidTypes));
  const canonicalTypes =
    uniqueTypes.length === 0
      ? [TrailerType.Tanker]
      : LIQUID_TRAILER_TYPES.filter((type) => uniqueTypes.includes(type));

  const [trailerType, ...additionalTrailerTypes] = canonicalTypes;
  return { trailerType, additionalTrailerTypes };
}
